import { MEDAL_REVIEW_ORDERS } from "@seagames/contracts";
import { z } from "zod";

/**
 * The desk's URL: `?event=<uuid>` opens that event (OVR's "Open in MSES"
 * links here), `?page=` is the queue page, `?q=` / `?sport=` / `?order=` the
 * queue's search, sport and grouping. A malformed value is dropped, not an
 * error page — a stale bookmark still opens the desk.
 */
export const deskSearch = z.object({
	event: z.string().uuid().optional().catch(undefined),
	page: z.coerce.number().int().min(1).max(10_000).optional().catch(undefined),
	q: z.string().trim().min(1).max(100).optional().catch(undefined),
	sport: z.string().uuid().optional().catch(undefined),
	order: z.enum(MEDAL_REVIEW_ORDERS).optional().catch(undefined),
});
export type DeskSearch = z.output<typeof deskSearch>;
